import React from 'react';
import { Breadcrumb } from 'antd';

function SummaryBreadcrumb({ drilldown = [], applyFilterFromBreadcrumb }) {

  const handleClickFn = (key) => {
    return (e) => {
      e.preventDefault();
      applyFilterFromBreadcrumb(key);
    }
  }

  return drilldown.length > 1 ? (
    <Breadcrumb separator=">" style={{
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      fontSize: 12,
    }}>
      {drilldown.map((item, key) => (
      <Breadcrumb.Item key={item.name} href="" onClick={handleClickFn(key)}>
        {item.name}
      </Breadcrumb.Item>
    ))}
    </Breadcrumb>
  ) : null;
}

export default SummaryBreadcrumb;
